import { createRestSlice } from "./restSlice";

export type AgentSessionEvent = {
  id: string;
  agentId: string;
  agentSessionId: string;
  name: string;
  data: Record<string, any>;
  timestamp: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const agentSessionEventSlice = createRestSlice<AgentSessionEvent>("agentSessionEvents", "/v1/sessions/:agentSessionId/events");

export const agentSessionEventReducer = agentSessionEventSlice.reducer;
export const agentSessionEventActions = agentSessionEventSlice.actions;
